import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export class IUser {
  name: string;
  surname: string;
  email: string;
  phone: string;
  username: string;
  id: number;
  fullname: string;
  tc: null | string;
  hidden: number;
  state: number;
  /** 1 = e-posta doğrulanmış */
  emailVerified?: number;
  /** 1 = telefon doğrulanmış */
  phoneVerified?: number;
  types?: ['vendor' | 'company'];
}

export class IUserResponse {
  @Type(() => IUser)
  result: IUser;
}

export class IUserListResponse extends IPagination {
  @Type(() => IUser)
  results: IUser[];
}

export class IUserQueryDto extends IQueryPaginationDto {
  name?: string;
  surname?: string;
  username?: string;
  email?: string;
  phone?: string;
  hidden?: number;
  state?: number;
  id?: string;
  companyId?: number | string;
}

export class IPostUserBodyDto {
  username: string;
  password: string;
  phone: string;
  email: string;
  name: string;
  surname: string;
  tc: string | null;
}

export class IPostUserInviteBodyDto {
  creatorId: number;
  email: string;
  vendorAccess?: {
    vendorId: number;
    companyId: number;
    accessLevel: string;
  };
  companyAccess?: {
    companyId: number;
    accessLevel: string;
  };
  status: string; // 'created'
  dateExpires: string;
  fullname: string;
}

export class IPatchUserBodyDto {
  username?: string;
  password?: string;
  phone?: string;
  email?: string;
  name?: string;
  surname?: string;
  tc?: string | null;
}

/** Kullanıcı aktif/pasif (users.state): 1 aktif, 0 pasif — yalnız SUPERADMIN */
export class IPatchUserStateBodyDto {
  state: 0 | 1;
}
